export enum DCUIThemingTextContentAcuantValidationTypes {
    BAD_RESOLUTION = "badResolution",
    BLUR_DETECTION = "blurDetection",
    GLARE_DETECTION = "glareDetection",
    LIVENESS_DETECTION= "livenessDetection"
}

export enum DetectionValidationHeader {
    LOW_SHARPNESS = "lowSharpness",
    LOW_DPI = "lowDPI",
    GLARE = "glare",
    LIVENESS = "liveness",
    FACE = "face",
}

export enum BlurDetection {
    VALID = "validSharpness",
    INVALID = "invalidSharpness"
}

export enum GlareDetection {
    VALID = "validGlare",
    INVALID = "invalidGlare"
}

export enum BadResolution {
    VALID = "validDPI",
    INVALID = "invalidDPI"
}

export enum LivenessDetection {
    VALID = "validLivenessDetected",
    INVALID = "livenessNotFoundError"
}